
import { Vue, Component } from 'vue-property-decorator';
import { verifyAndAddNewUserToAccountService, verifyPasswordTokenService } from '@/features/auth/services/auth.services';
import ChangePasswordForm, { FormData } from '@/features/auth/components/changePassword/ChangePasswordForm.vue';

@Component({
  components: {
    ChangePasswordForm,
  },
})
export default class VerifyUser extends Vue {
  private verifyError = false;

  private verifyLoading = false;

  private isPasswordResetForm = false;

  private errorMessage = '';

  get id(): string {
    return this.$route.query.id as string;
  }

  get key(): string {
    return this.$route.query.key as string;
  }

  get isAuth(): boolean {
    return this.$store.getters.getIsAuth;
  }

  get unableToProceed(): boolean {
    return this.verifyError || this.isAuth;
  }

  get message(): string {
    let messageName = 'verifyEmailLoading';

    if (this.isAuth) {
      messageName = 'alreadyLoggedIn';
    } else if (this.verifyError) {
      messageName = 'verifyEmailError';
    } else if (this.verifyLoading) {
      messageName = 'verifyEmailLoading';
    }

    return this.$t(`verifyUser.messages.${messageName}`) as string;
  }

  get imageName(): string {
    const isOops = this.verifyError || this.isAuth;
    return isOops ? 'mascot-no-permission' : 'mascot-welcome';
  }

  get showActionButton(): boolean {
    return this.isAuth || this.verifyError;
  }

  get actionButtonTo(): { [key: string]: string } | string {
    return this.isAuth ? { name: 'logout' } : '/';
  }

  get actionButtonText(): string {
    return this.$t(`buttons.${this.isAuth ? 'logout' : 'homepage'}`) as string;
  }

  private async created(): Promise<void> {
    this.$store.commit('setLoading', false);

    if (this.isAuth) return;

    if (!this.id || !this.key) {
      this.verifyError = true;
      return;
    }

    this.verifyLoading = true;
    const response = await verifyPasswordTokenService(this.id, this.key);
    this.verifyLoading = false;

    if (!response.successful) {
      this.showErrorMessage();
      return;
    }

    this.isPasswordResetForm = true;
  }

  private async submit({ pass, confirmPass }: FormData) {
    if (!this.id || !this.key) {
      this.showErrorMessage();
      return;
    }

    this.$store.commit('setLoading', true);
    const response = await verifyAndAddNewUserToAccountService(
      pass,
      confirmPass,
      this.id,
      this.key,
    );
    this.$store.commit('setLoading', false);

    if (!response.successful || !response.data) {
      this.errorMessage = response.errorMessage || '';
      return;
    }

    this.$store.dispatch(
      'signIn',
      { tokenData: response.data, redirectTo: this.$route.query.redirectTo },
    );
  }

  private showErrorMessage() {
    this.verifyError = true;
    this.isPasswordResetForm = false;
  }
}
